// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaPlus, FaTrash } from "react-icons/fa";
// import { useNavigate, useParams } from "react-router-dom";

// const SalesOrders = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const fetchOrderById = async (orderId) => {
//     try {
//       const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${orderId}`);
//       const order = res.data;
//       const items = typeof order.items === "string" ? JSON.parse(order.items) : order.items;
//       setNewOrder({ ...order, items });
//     } catch (err) {
//       console.error("Error fetching order:", err);
//       alert("❌ Failed to load order details");
//     }
//   };
//   useEffect(() => {
//     if (id) fetchOrderById(id);
//   }, [id]);



//   // --- Order form state
//   const [newOrder, setNewOrder] = useState({
//     order_number: "",
//     customer_id: "",
//     customer_name: "",
//     order_date: "",
//     gst: "",
//     gst_amount: 0,
//     discount: '',
//     total_amount: 0,
//     shipping_address: "",
//     items: [],
//     notes: "",
//     user_id: "",
//   });


//   const [newItem, setNewItem] = useState({
//     product_name: "",
//     thickness: "",
//     grade: "",
//     size: "",
//     quantity: "",
//     unit_price: "",
//   });

//   const [gstEntries, setGstEntries] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [products, setProducts] = useState([]);

//   // Fetch GST list
//   useEffect(() => {
//     const fetchGst = async () => {
//       try {
//         const user = JSON.parse(sessionStorage.getItem("userData"));
//         if (!user?.id) return;
//         const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/api/gst", {
//           headers: { "x-user-id": user.id },
//         });
//         setGstEntries(res.data);
//       } catch (err) {
//         console.error("Error fetching GST entries:", err);
//       }
//     };
//     fetchGst();
//   }, []);

//   // Fetch interested customers
//   useEffect(() => {
//     const fetchLeads = async () => {
//       try {
//         const user = JSON.parse(sessionStorage.getItem("userData"));
//         if (!user?.id) return;
//         const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/lead_management", {
//           params: { user_id: user.id },
//         });
//         setCustomers(res.data.filter((c) => c.status === "INTERESTED"));
//       } catch (err) {
//         console.error("Error fetching leads:", err);
//       }
//     };
//     fetchLeads();
//   }, []);

//   // Fetch products
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const user = JSON.parse(sessionStorage.getItem("userData"));
//         if (!user?.id) return;
//         const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/ordersapi?user_id=${user.id}`);
//         setProducts(res.data);
//       } catch (err) {
//         console.error("Error fetching products:", err);
//       }
//     };
//     fetchProducts();
//   }, []);

//   // Handle input change
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     let updatedValue = value;

//     // Apply discount dynamically
//     if (name === "discount" || name === "gst") {
//       updatedValue = value;
//       calculateTotal(newOrder.items, name === "discount" ? Number(value) : newOrder.discount, name === "gst" ? value : newOrder.gst);
//     }

//     setNewOrder((prev) => ({
//       ...prev,
//       [name]: updatedValue,
//     }));
//   };

//   // Handle adding item
//   const handleItemChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "product_name") {
//       const selectedProduct = products.find((p) => p.name === value);
//       if (selectedProduct) {
//         setNewItem({
//           product_name: selectedProduct.name,
//           thickness: selectedProduct.thickness || "",
//           grade: selectedProduct.grade || "",
//           size: selectedProduct.size || "",
//           unit_price: selectedProduct.price || "",
//           quantity: "",
//         });
//       }
//     } else {
//       setNewItem((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Add item to order
//   const handleAddItem = (e) => {
//     e.preventDefault();
//     if (!newItem.product_name || !newItem.quantity || !newItem.unit_price) {
//       alert("Please fill all item fields");
//       return;
//     }
//     const updatedItems = [
//       ...newOrder.items,
//       {
//         product_name: newItem.product_name,
//         thickness: newItem.thickness || "",
//         grade: newItem.grade || "",
//         size: newItem.size || "",
//         quantity: Number(newItem.quantity),
//         unit_price: Number(newItem.unit_price),
//       },
//     ];
//     calculateTotal(updatedItems, newOrder.discount, newOrder.gst);
//     setNewOrder((prev) => ({ ...prev, items: updatedItems }));
//     setNewItem({ product_name: "", quantity: "", unit_price: "" });
//   };

//   // Remove item
//   const handleRemoveItem = (index) => {
//     const updatedItems = newOrder.items.filter((_, i) => i !== index);
//     calculateTotal(updatedItems, newOrder.discount, newOrder.gst);
//     setNewOrder((prev) => ({ ...prev, items: updatedItems }));
//   };

//   // GST + Discount calculation
//   const calculateTotal = (items, discount, gstValue) => {
//     const subtotal = items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0);
//     const discountAmount = (subtotal * (discount || 0)) / 100;

//     let gstRate = 0;
//     if (gstValue) {
//       const match = gstValue.match(/(\d+(\.\d+)?)/);
//       if (match) gstRate = parseFloat(match[0]);
//     }

//     const taxableAmount = subtotal - discountAmount;
//     const gstAmount = (taxableAmount * gstRate) / 100;
//     const total = taxableAmount + gstAmount;

//     setNewOrder((prev) => ({
//       ...prev,
//       total_amount: total,
//       gst_amount: gstAmount,
//     }));
//   };

//   // Submit order
//   const handleAddNewOrder = async (e) => {
//     e.preventDefault();
//     const user = JSON.parse(sessionStorage.getItem("userData"));
//     if (!user?.id) {
//       alert("User not logged in!");
//       return;
//     }

//     if (!newOrder.customer_name || !newOrder.order_number) {
//       alert("Please enter customer name and order number");
//       return;
//     }

//     if (newOrder.items.length === 0) {
//       alert("Please add at least one item");
//       return;
//     }

//     try {
//       if (id) {
//         await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${id}`, newOrder);
//         alert("✅ Order updated successfully!");
//       } else {
//         const orderData = { ...newOrder, user_id: user.id };
//         await axios.post(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders`, orderData);
//         alert("✅ Order added successfully!");
//       }
//       navigate("/dashboard/SalesOrderList");
//       setNewOrder({
//         order_number: "",
//         customer_id: "",
//         customer_name: "",
//         order_date: "",
//         gst: "",
//         gst_amount: 0,
//         discount: 0,
//         total_amount: 0,
//         shipping_address: "",
//         items: [],
//         notes: "",
//         user_id: "",
//       });
//     } catch (err) {
//       console.error("Error adding new order:", err);
//       alert("Failed to save order");
//     } finally {
//       console.log(false);
//     }
//   };


//   return (
//     <div style={{ fontFamily: "'Inter', sans-serif", minHeight: "100vh", }}>
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px", }}>
//         <h2 style={{ margin: 0, color: "#1e293b", fontSize: "20px", fontWeight: 600, }}>🧾 Sales Orders</h2>
//       </div>

//       <div style={{ overflowX: "auto", width: "100%", background: "#fff", padding: "2px", borderRadius: '5px' }}>
//         <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: "800px" }}>
//           <thead>
//             <tr style={{ backgroundColor: "#e2e8f0", textAlign: "left" }}>
//               <th style={{ padding: "8px" }}>Order No #</th>
//               <th style={{ padding: "8px" }}>Customer</th>
//               <th style={{ padding: "8px" }}>Order Date</th>
//               <th style={{ padding: "8px" }}>GST</th>
//               <th style={{ padding: "8px" }}>Total Amount</th>
//               <th style={{ padding: "8px", textAlign: "center" }}>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr style={{ background: "#f0fdf4" }}>
//               <td style={{ padding: "8px" }}><input name="order_number" value={newOrder.order_number} onChange={handleInputChange} placeholder="Order No #" style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} /></td>
//               <td style={{ padding: "8px" }}>
//                 <select name="customer_name" value={newOrder.customer_name} onChange={(e) => {
//                   const selectedCustomer = customers.find((cust) => cust.name === e.target.value);
//                   setNewOrder((prev) => ({
//                     ...prev,
//                     customer_name: selectedCustomer?.name || "",
//                     customer_id: selectedCustomer?.id || "",
//                   }));
//                 }}
//                   style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }}
//                 >
//                   <option value="">Select Interested Customer</option>
//                   {customers.length > 0 ? (customers.map((cust) => (
//                     <option key={cust.id} value={cust.name}>
//                       {cust.name}
//                     </option>
//                   ))
//                   ) : (
//                     <option disabled>No interested customers</option>
//                   )}
//                 </select>
//               </td>
//               <td style={{ padding: "8px" }}><input type="date" name="order_date" value={newOrder.order_date} onChange={handleInputChange} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} /></td>
//               <td style={{ padding: "8px" }}>
//                 <select name="gst" value={newOrder.gst} onChange={handleInputChange} style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }}>
//                   <option value="">Select GST</option>
//                   {gstEntries.map((gst, index) => (
//                     <React.Fragment key={index}>
//                       <option value={`CGST ${gst.cgst}%`}>CGST {gst.cgst}%</option>
//                       <option value={`SGST ${gst.sgst}%`}>SGST {gst.sgst}%</option>
//                       <option value={`IGST ${gst.igst}%`}>IGST {gst.igst}%</option>
//                     </React.Fragment>
//                   ))}
//                 </select>
//               </td>
//               <td style={{ padding: "8px" }}><input type="number" name="total_amount" value={newOrder.total_amount} readOnly style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, background: "#f9fafb", fontWeight: 500, }} /></td>
//               <td style={{ textAlign: "center" }}><button onClick={handleAddNewOrder} style={{ ...{ padding: "6px 12px", fontSize: "13px", cursor: "pointer", color: "#fff", border: "none", borderRadius: "6px", transition: "background 0.3s ease", }, backgroundColor: "#16a34a", }}><FaPlus /> Add </button></td>
//             </tr>
//             <tr>
//               <td style={{ padding: "8px", width: "25%" }}><textarea name="shipping_address" value={newOrder.shipping_address} onChange={handleInputChange} placeholder="Shipping Address" style={{ width: "100%", height: '80px', padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} /></td>
//               <td style={{ padding: "8px", width: "25%" }}><textarea name="notes" value={newOrder.notes} onChange={handleInputChange} placeholder="Notes" style={{ width: "100%", height: '80px', padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} /></td>
//               <td style={{ padding: "8px" }}><input name="discount" value={newOrder.discount} onChange={handleInputChange} placeholder="discount %" style={{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }} /></td>
//             </tr>

//             <tr>
//               <td colSpan="9" style={{ padding: "16px", background: "#f9fffa" }}>
//                 <strong style={{ color: "#1e293b" }}>Add Items</strong>
//                 <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap", }}>
//                   <select name="product_name" value={newItem.product_name} onChange={handleItemChange} style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }}>
//                     <option value="">Select Product</option>
//                     {products.map((p) => (
//                       <option key={p.id} value={p.name}>
//                         {p.name}
//                       </option>
//                     ))}
//                   </select>

//                   <input type="text" name="thickness" value={newItem.thickness} onChange={handleItemChange} placeholder="Thickness" style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }} />
//                   <input type="text" name="grade" value={newItem.grade} onChange={handleItemChange} placeholder="Grade" style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }} />
//                   <input type="text" name="size" value={newItem.size} onChange={handleItemChange} placeholder="Size" style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }} />
//                   <input type="number" name="unit_price" value={newItem.unit_price} onChange={handleItemChange} placeholder="Unit Price" style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }} />
//                   <input type="number" name="quantity" value={newItem.quantity} onChange={handleItemChange} placeholder="Qty" style={{ ...{ width: "100%", padding: "6px 8px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", transition: "border 0.2s ease, box-shadow 0.2s ease", outline: "none", }, flex: "1" }} />
//                   <button onClick={handleAddItem} style={{ ...{ padding: "6px 12px", fontSize: "13px", cursor: "pointer", color: "#fff", border: "none", borderRadius: "6px", transition: "background 0.3s ease", }, backgroundColor: "#059669", flexShrink: 0, }}><FaPlus /> Item</button>
//                 </div>

//                 {newOrder.items.length > 0 && (
//                   <ul style={{ marginTop: "15px", paddingLeft: "18px", color: "#334155", }}>
//                     {newOrder.items.map((item, idx) => (
//                       <li key={idx} style={{ marginBottom: "6px", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
//                         {item.product_name} — Qty: {item.quantity} × ₹
//                         {item.unit_price.toFixed(2)}
//                         <button onClick={() => handleRemoveItem(idx)} style={{ background: "transparent", border: "none", color: "#dc2626", cursor: "pointer", }}><FaTrash /></button>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>

//   );
// };

// export default SalesOrders;


// import React, { useState, useEffect } from 'react';
// import {
//   Plus, ChevronDown, ShoppingCart, Building2,
//   Calendar, Hash, Save, X, Mail, Phone as PhoneIcon, Landmark,
//   User, MapPin, FileText, Tag
// } from 'lucide-react';

// const CUSTOMER_DATA = [
//   { id: '1', name: 'John Doe', email: 'john.doe@example.com', phone: '+91 98765 43210', gstin: '27AAAAA1111A1Z1', billingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001', shippingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001' },
//   { id: '2', name: 'Acme Corp', email: 'billing@acme.com', phone: '+91 99999 88888', gstin: '07AAAAA2222B2Z2', billingAddress: 'Tech Park, Block B, New Delhi, DL, 110001', shippingAddress: 'Warehouse 4, Okhla Phase 3, New Delhi, DL, 110020' },
//   { id: '3', name: 'TechStart Inc', email: 'finance@techstart.io', phone: '+91 88888 77777', gstin: '29AAAAA3333C3Z3', billingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034', shippingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034' },
//   { id: '4', name: 'Global Inc', email: 'accounts@globalinc.com', phone: '+91 77777 66666', gstin: '33AAAAA4444D4Z4', billingAddress: 'Anna Salai, T Nagar, Chennai, TN, 600017', shippingAddress: 'Anna Salai, T Nagar, Chennai, TN, 600017' },
// ];

// const SALESPERSONS = ['Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Nair', 'Vivek Menon'];

// const PRODUCTS = [
//   { name: 'Teak Divine Noir Wood HZ', code: 'TK-001', hsn: '44079900', unit: 'SQM', rate: 2400, gst: 18 },
//   { name: 'Ash Dyed Velvet Grey', code: 'DY-005', hsn: '44079900', unit: 'SQM', rate: 1850, gst: 18 },
//   { name: 'Smoked Oak Premium', code: 'SM-003', hsn: '44079900', unit: 'SQM', rate: 3100, gst: 18 },
//   { name: 'Herringbone Classic', code: 'HB-002', hsn: '44071500', unit: 'SQM', rate: 2750, gst: 12 },
//   { name: 'Edgewood Natural', code: 'EW-007', hsn: '44071500', unit: 'SQM', rate: 1600, gst: 12 },
//   { name: 'Tan Wood Series Standard', code: 'TW-010', hsn: '44071500', unit: 'SQM', rate: 1200, gst: 12 },
// ];

// function createLine(id) {
//   return { id, productName: '', qty: 1, rate: 0, discount: 0, amount: 0, gstRate: 0 };
// }

// function calcAmount(qty, rate, discount) {
//   return parseFloat((qty * rate * (1 - discount / 100)).toFixed(2));
// }

// const SalesOrders = () => {
//   // Screen size state for responsive layouts tracking
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 640;
//   const isTabletOrMobile = windowWidth < 1024;

//   // Sale Details State
//   const [saleNo] = useState(`SO-${String(Date.now()).slice(-5)}`);
//   const [saleDate, setSaleDate] = useState(new Date().toISOString().split('T')[0]);
//   const [deliveryDate, setDeliveryDate] = useState('');
//   const [status, setStatus] = useState('Draft');
//   const [salesperson, setSalesperson] = useState('');
//   const [poReference, setPoReference] = useState('');

//   // Customer State
//   const [selectedCustomerId, setSelectedCustomerId] = useState('');
//   const [customerEmail, setCustomerEmail] = useState('');
//   const [customerPhone, setCustomerPhone] = useState('');
//   const [customerGstin, setCustomerGstin] = useState('');
//   const [billingAddress, setBillingAddress] = useState('');
//   const [shippingAddress, setShippingAddress] = useState('');

//   // Line items state
//   const [items, setItems] = useState([createLine(1)]);
//   const [showProductDrop, setShowProductDrop] = useState(null);

//   // Notes
//   const [notes, setNotes] = useState('');

//   const handleCustomerChange = (id) => {
//     setSelectedCustomerId(id);
//     const client = CUSTOMER_DATA.find(c => c.id === id);
//     if (client) {
//       setCustomerEmail(client.email);
//       setCustomerPhone(client.phone);
//       setCustomerGstin(client.gstin);
//       setBillingAddress(client.billingAddress);
//       setShippingAddress(client.shippingAddress);
//     } else {
//       setCustomerEmail('');
//       setCustomerPhone('');
//       setCustomerGstin('');
//       setBillingAddress('');
//       setShippingAddress('');
//     }
//   };

//   const selectProduct = (lineId, product) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== lineId) return item;
//       return { 
//         ...item, 
//         productName: product.name, 
//         rate: product.rate, 
//         gstRate: product.gst,
//         amount: calcAmount(item.qty, product.rate, item.discount) 
//       };
//     }));
//     setShowProductDrop(null);
//   };

//   const updateLineField = (id, field, value) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== id) return item;
//       const updated = { ...item, [field]: value };
      
//       if (field === 'productName') {
//         const exactProd = PRODUCTS.find(p => p.name.toLowerCase() === value.toLowerCase());
//         if (exactProd) updated.gstRate = exactProd.gst;
//       }

//       updated.amount = calcAmount(updated.qty, updated.rate, updated.discount);
//       return updated;
//     }));
//   };

//   const addLine = () => {
//     const newId = items.length > 0 ? Math.max(...items.map(i => i.id)) + 1 : 1;
//     setItems(prev => [...prev, createLine(newId)]);
//   };

//   const removeLine = (id) => {
//     if (items.length === 1) return;
//     setItems(prev => prev.filter(i => i.id !== id));
//   };

//   // Dynamic computations
//   const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
//   const gstAmount = items.reduce((sum, item) => sum + (item.amount * (item.gstRate / 100)), 0);
//   const totalAmount = subtotal + gstAmount;

//   // Global Reusable Dynamic Inline Styles
//   const styles = {
//     container: {
//       padding: isMobile ? '16px' : '32px',
//       maxWidth: '1024px',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       backgroundColor: '#f5f5f5',
//       minHeight: '100vh',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       boxSizing: 'border-box'
//     },
//     headerRow: {
//       display: 'flex',
//       flexDirection: isMobile ? 'column' : 'row',
//       alignItems: isMobile ? 'flex-start' : 'center',
//       justifyContent: 'space-between',
//       gap: '16px',
//       borderBottom: '1px solid #e5e5e5',
//       paddingBottom: '16px',
//       marginBottom: '24px'
//     },
//     title: {
//       fontSize: '20px',
//       fontWeight: '700',
//       color: '#171717',
//       margin: 0
//     },
//     subtitle: {
//       color: '#737373',
//       fontSize: '14px',
//       margin: '4px 0 0 0'
//     },
//     btnGroup: {
//       display: 'flex',
//       gap: '8px',
//       width: isMobile ? '100%' : 'auto'
//     },
//     btnSecondary: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       padding: '8px 16px',
//       backgroundColor: '#f5f5f5',
//       color: '#404040',
//       borderRadius: '12px',
//       border: '1px solid #e5e5e5',
//       fontSize: '14px',
//       cursor: 'pointer',
//       flex: isMobile ? 1 : 'none',
//       transition: 'background-color 0.2s'
//     },
//     btnPrimary: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       padding: '8px 16px',
//       backgroundColor: '#2563eb',
//       color: '#ffffff',
//       borderRadius: '12px',
//       border: 'none',
//       fontSize: '14px',
//       cursor: 'pointer',
//       flex: isMobile ? 1 : 'none',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//       transition: 'background-color 0.2s'
//     },
//     mainLayout: {
//       display: 'grid',
//       gridTemplateColumns: isTabletOrMobile ? '1fr' : '2fr 1fr',
//       gap: '24px',
//       alignItems: 'start'
//     },
//     leftColumn: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '24px'
//     },
//     card: {
//       backgroundColor: '#ffffff',
//       border: '1px solid #e5e5e5',
//       borderRadius: '16px',
//       padding: '20px',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.01)'
//     },
//     cardHeader: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       marginBottom: '16px'
//     },
//     cardTitle: {
//       color: '#262626',
//       fontWeight: '600',
//       fontSize: '14px',
//       textTransform: 'uppercase',
//       letterSpacing: '0.05em',
//       margin: 0
//     },
//     grid2Col: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//       gap: '16px'
//     },
//     grid3Col: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
//       gap: '16px'
//     },
//     label: {
//       display: 'block',
//       fontSize: '12px',
//       fontWeight: '600',
//       color: '#737373',
//       textTransform: 'uppercase',
//       letterSpacing: '0.05em',
//       marginBottom: '4px'
//     },
//     inputWrapper: {
//       position: 'relative',
//       width: '100%'
//     },
//     inputIcon: {
//       position: 'absolute',
//       left: '12px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: '16px',
//       height: '16px',
//       color: '#a3a3a3',
//       pointerEvents: 'none'
//     },
//     input: {
//       width: '100%',
//       padding: '8px 12px',
//       fontSize: '14px',
//       backgroundColor: '#fafafa',
//       border: '1px solid #e5e5e5',
//       borderRadius: '12px',
//       outline: 'none',
//       boxSizing: 'border-box'
//     },
//     inputWithIcon: {
//       width: '100%',
//       padding: '8px 12px 8px 36px',
//       fontSize: '14px',
//       backgroundColor: '#fafafa',
//       border: '1px solid #e5e5e5',
//       borderRadius: '12px',
//       outline: 'none',
//       boxSizing: 'border-box'
//     },
//     selectWithIcon: {
//       width: '100%',
//       padding: '8px 40px 8px 36px',
//       fontSize: '14px',
//       backgroundColor: '#fafafa',
//       border: '1px solid #e5e5e5',
//       borderRadius: '12px',
//       outline: 'none',
//       appearance: 'none',
//       boxSizing: 'border-box'
//     },
//     chevronIcon: {
//       position: 'absolute',
//       right: '12px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: '16px',
//       height: '16px',
//       color: '#a3a3a3',
//       pointerEvents: 'none'
//     },
//     statusGroup: {
//       display: 'flex',
//       backgroundColor: '#f5f5f5',
//       padding: '4px',
//       borderRadius: '12px',
//       gap: '4px'
//     },
//     statusBtn: (isActive) => ({
//       flex: 1,
//       padding: '6px 0',
//       fontSize: '12px',
//       fontWeight: '500',
//       borderRadius: '8px',
//       border: 'none',
//       cursor: 'pointer',
//       transition: 'all 0.2s',
//       backgroundColor: isActive ? '#ffffff' : 'transparent',
//       color: isActive ? '#171717' : '#737373',
//       boxShadow: isActive ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none',
//       border: isActive ? '1px solid #e5e5e5' : '1px solid transparent'
//     }),
//     textarea: {
//       width: '100%',
//       padding: '8px 12px',
//       fontSize: '14px',
//       backgroundColor: '#fafafa',
//       border: '1px solid #e5e5e5',
//       borderRadius: '12px',
//       outline: 'none',
//       resize: 'none',
//       boxSizing: 'border-box'
//     },
//     tableHeadCell: (alignment, width) => ({
//       textAlign: alignment,
//       paddingBottom: '8px',
//       fontWeight: '500',
//       fontSize: '12px',
//       color: '#737373',
//       textTransform: 'uppercase',
//       letterSpacing: '0.05em',
//       width: width || 'auto'
//     }),
//     dropdownContainer: {
//       position: 'absolute',
//       zIndex: 30,
//       left: 0,
//       top: '100%',
//       marginTop: '4px',
//       width: '100%',
//       backgroundColor: '#ffffff',
//       border: '1px solid #e5e5e5',
//       borderRadius: '12px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
//       maxHeight: '192px',
//       overflowY: 'auto'
//     },
//     dropdownRowBtn: {
//       width: '100%',
//       textAlign: 'left',
//       padding: '8px 12px',
//       backgroundColor: 'transparent',
//       border: 'none',
//       borderBottom: '1px solid #fafafa',
//       cursor: 'pointer',
//       boxSizing: 'border-box'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Page Header */}
//       <div style={styles.headerRow}>
//         <div>
//           <h1 style={styles.title}>Sales Orders</h1>
//           <p style={styles.subtitle}>Create and manage customer sales orders</p>
//         </div>
//         <div style={styles.btnGroup}>
//           <button style={styles.btnSecondary}>
//             <Save style={{ width: '16px', height: '16px' }} />
//             Save Draft
//           </button>
//           <button style={styles.btnPrimary}>
//             <ShoppingCart style={{ width: '16px', height: '16px' }} />
//             Confirm Order
//           </button>
//         </div>
//       </div>

//       <div style={styles.mainLayout}>
//         {/* Left: Main Form */}
//         <div style={styles.leftColumn}>

//           {/* Sale Details Card */}
//           <div style={styles.card}>
//             <div style={styles.cardHeader}>
//               <ShoppingCart style={{ width: '16px', height: '16px', color: '#3b82f6' }} />
//               <h2 style={styles.cardTitle}>Sale Order Details</h2>
//             </div>

//             <div style={styles.grid2Col}>
//               <div>
//                 <label style={styles.label}>Order Number</label>
//                 <div style={styles.inputWrapper}>
//                   <Hash style={styles.inputIcon} />
//                   <input 
//                     value={saleNo} 
//                     readOnly 
//                     style={{ ...styles.inputWithIcon, backgroundColor: '#f5f5f5', cursor: 'not-allowed', color: '#737373' }} 
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.label}>Order Date</label>
//                 <div style={styles.inputWrapper}>
//                   <Calendar style={styles.inputIcon} />
//                   <input
//                     type="date"
//                     value={saleDate}
//                     onChange={e => setSaleDate(e.target.value)}
//                     style={styles.inputWithIcon}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.label}>Delivery Date</label>
//                 <div style={styles.inputWrapper}>
//                   <Calendar style={styles.inputIcon} />
//                   <input
//                     type="date"
//                     value={deliveryDate}
//                     onChange={e => setDeliveryDate(e.target.value)}
//                     style={styles.inputWithIcon}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.label}>Status</label>
//                 <div style={styles.statusGroup}>
//                   {['Draft', 'Confirmed', 'Processing'].map(s => (
//                     <button
//                       key={s}
//                       type="button"
//                       onClick={() => setStatus(s)}
//                       style={styles.statusBtn(status === s)}
//                     >
//                       {s}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.label}>Salesperson</label>
//                 <div style={styles.inputWrapper}>
//                   <User style={styles.inputIcon} />
//                   <select
//                     value={salesperson}
//                     onChange={e => setSalesperson(e.target.value)}
//                     style={styles.selectWithIcon}
//                   >
//                     <option value="">-- Assign Salesperson --</option>
//                     {SALESPERSONS.map(s => <option key={s}>{s}</option>)}
//                   </select>
//                   <ChevronDown style={styles.chevronIcon} />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.label}>PO / Reference No.</label>
//                 <div style={styles.inputWrapper}>
//                   <Tag style={styles.inputIcon} />
//                   <input
//                     value={poReference}
//                     onChange={e => setPoReference(e.target.value)}
//                     placeholder="Customer PO number"
//                     style={styles.inputWithIcon}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Customer Info Card */}
//           <div style={styles.card}>
//             <div style={styles.cardHeader}>
//               <Building2 style={{ width: '16px', height: '16px', color: '#a855f7' }} />
//               <h2 style={styles.cardTitle}>Customer Info</h2>
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//               <div>
//                 <label style={styles.label}>Select Interested Customer</label>
//                 <div style={styles.inputWrapper}>
//                   <select
//                     value={selectedCustomerId}
//                     onChange={e => handleCustomerChange(e.target.value)}
//                     style={{ ...styles.input, paddingRight: '40px', appearance: 'none' }}
//                   >
//                     <option value="">-- Select Customer --</option>
//                     {CUSTOMER_DATA.map(c => (
//                       <option key={c.id} value={c.id}>{c.name}</option>
//                     ))}
//                   </select>
//                   <ChevronDown style={styles.chevronIcon} />
//                 </div>
//               </div>

//               <div style={styles.grid3Col}>
//                 <div>
//                   <label style={styles.label}>Email</label>
//                   <div style={styles.inputWrapper}>
//                     <Mail style={styles.inputIcon} />
//                     <input
//                       type="email"
//                       value={customerEmail}
//                       onChange={e => setCustomerEmail(e.target.value)}
//                       placeholder="email@example.com"
//                       style={styles.inputWithIcon}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={styles.label}>Phone</label>
//                   <div style={styles.inputWrapper}>
//                     <PhoneIcon style={styles.inputIcon} />
//                     <input
//                       type="text"
//                       value={customerPhone}
//                       onChange={e => setCustomerPhone(e.target.value)}
//                       placeholder="Phone number"
//                       style={styles.inputWithIcon}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={styles.label}>GSTIN</label>
//                   <div style={styles.inputWrapper}>
//                     <Landmark style={styles.inputIcon} />
//                     <input
//                       type="text"
//                       value={customerGstin}
//                       onChange={e => setCustomerGstin(e.target.value)}
//                       placeholder="GSTIN reference"
//                       style={styles.inputWithIcon}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.grid2Col}>
//                 <div>
//                   <label style={styles.label}>
//                     <MapPin style={{ display: 'inline', width: '12px', height: '12px', marginRight: '4px', verticalAlign: 'middle' }} />
//                     Billing Address
//                   </label>
//                   <textarea
//                     rows={2}
//                     value={billingAddress}
//                     onChange={e => setBillingAddress(e.target.value)}
//                     placeholder="Enter billing address"
//                     style={styles.textarea}
//                   />
//                 </div>
//                 <div>
//                   <label style={styles.label}>
//                     <MapPin style={{ display: 'inline', width: '12px', height: '12px', marginRight: '4px', verticalAlign: 'middle' }} />
//                     Shipping / Delivery Address
//                   </label>
//                   <textarea
//                     rows={2}
//                     value={shippingAddress}
//                     onChange={e => setShippingAddress(e.target.value)}
//                     placeholder="Enter delivery address"
//                     style={styles.textarea}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Order Items Card */}
//           <div style={styles.card}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//               <h2 style={styles.cardTitle}>Order Items</h2>
//               <button
//                 type="button"
//                 onClick={addLine}
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '6px',
//                   padding: '6px 12px',
//                   backgroundColor: '#eff6ff',
//                   color: '#2563eb',
//                   borderRadius: '8px',
//                   border: '1px solid #dbeafe',
//                   fontSize: '12px',
//                   fontWeight: '500',
//                   cursor: 'pointer'
//                 }}
//               >
//                 <Plus style={{ width: '14px', height: '14px' }} />
//                 Add Item
//               </button>
//             </div>

//             {/* Desktop Table View */}
//             {!isMobile && (
//               <div style={{ overflow: 'visible' }}>
//                 <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
//                   <thead>
//                     <tr style={{ borderBottom: '1px solid #f5f5f5' }}>
//                       <th style={styles.tableHeadCell('left', '35%')}>Select Product Description</th>
//                       <th style={styles.tableHeadCell('center', '10%')}>Qty</th>
//                       <th style={styles.tableHeadCell('right', '15%')}>Rate (₹)</th>
//                       <th style={styles.tableHeadCell('center', '12%')}>Disc %</th>
//                       <th style={styles.tableHeadCell('left', '13%')}>Select GST</th>
//                       <th style={styles.tableHeadCell('right', '12%')}>Amount</th>
//                       <th style={styles.tableHeadCell('center', '3%')} />
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {items.map(item => (
//                       <tr key={item.id}>
//                         <td style={{ padding: '12px 8px 12px 0', position: 'relative' }}>
//                           <input
//                             value={item.productName}
//                             onChange={e => updateLineField(item.id, 'productName', e.target.value)}
//                             onFocus={() => setShowProductDrop(item.id)}
//                             onBlur={() => setTimeout(() => setShowProductDrop(null), 250)}
//                             placeholder="Type item description..."
//                             style={{ ...styles.input, backgroundColor: '#fafafa' }}
//                           />
//                           {showProductDrop === item.id && (
//                             <div style={styles.dropdownContainer}>
//                               {PRODUCTS.filter(p => p.name.toLowerCase().includes(item.productName.toLowerCase())).map(p => (
//                                 <button
//                                   key={p.code}
//                                   type="button"
//                                   onMouseDown={() => selectProduct(item.id, p)}
//                                   style={styles.dropdownRowBtn}
//                                 >
//                                   <div style={{ fontWeight: '600', color: '#404040', fontSize: '12px' }}>{p.name}</div>
//                                   <div style={{ color: '#a3a3a3', fontSize: '10px' }}>Rate: ₹{p.rate} | Unit: {p.unit} | GST: {p.gst}%</div>
//                                 </button>
//                               ))}
//                             </div>
//                           )}
//                         </td>
//                         <td style={{ padding: '12px 8px' }}>
//                           <input
//                             type="number"
//                             min={1}
//                             value={item.qty || ''}
//                             onChange={e => updateLineField(item.id, 'qty', parseInt(e.target.value) || 0)}
//                             style={{ ...styles.input, textAlign: 'center' }}
//                           />
//                         </td>
//                         <td style={{ padding: '12px 8px' }}>
//                           <input
//                             type="number"
//                             min={0}
//                             value={item.rate || ''}
//                             onChange={e => updateLineField(item.id, 'rate', parseFloat(e.target.value) || 0)}
//                             style={{ ...styles.input, textAlign: 'right' }}
//                           />
//                         </td>
//                         <td style={{ padding: '12px 8px' }}>
//                           <input
//                             type="number"
//                             min={0}
//                             max={100}
//                             value={item.discount || ''}
//                             onChange={e => updateLineField(item.id, 'discount', parseFloat(e.target.value) || 0)}
//                             style={{ ...styles.input, textAlign: 'center' }}
//                           />
//                         </td>
//                         <td style={{ padding: '12px 8px' }}>
//                           <select
//                             value={item.gstRate}
//                             onChange={e => updateLineField(item.id, 'gstRate', parseInt(e.target.value) || 0)}
//                             style={styles.input}
//                           >
//                             <option value={0}>0%</option>
//                             <option value={5}>5%</option>
//                             <option value={12}>12%</option>
//                             <option value={18}>18%</option>
//                             <option value={28}>28%</option>
//                           </select>
//                         </td>
//                         <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: '500', color: '#262626' }}>
//                           ₹{item.amount.toFixed(2)}
//                         </td>
//                         <td style={{ padding: '12px 0 12px 8px', textAlign: 'right' }}>
//                           <button
//                             type="button"
//                             onClick={() => removeLine(item.id)}
//                             disabled={items.length === 1}
//                             style={{
//                               padding: '4px',
//                               border: 'none',
//                               backgroundColor: 'transparent',
//                               color: '#d4d4d4',
//                               cursor: items.length === 1 ? 'not-allowed' : 'pointer',
//                               opacity: items.length === 1 ? 0.3 : 1,
//                               transition: 'color 0.2s'
//                             }}
//                           >
//                             <X style={{ width: '16px', height: '16px' }} />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             {/* Mobile Cards Stack View */}
//             {isMobile && (
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                 {items.map(item => (
//                   <div key={item.id} style={{ border: '1px solid #e5e5e5', borderRadius: '12px', padding: '12px', position: 'relative', backgroundColor: 'rgba(250,250,250,0.4)' }}>
//                     <button
//                       type="button"
//                       onClick={() => removeLine(item.id)}
//                       disabled={items.length === 1}
//                       style={{ position: 'absolute', top: '8px', right: '8px', border: 'none', backgroundColor: 'transparent', color: '#d4d4d4', opacity: items.length === 1 ? 0.2 : 1 }}
//                     >
//                       <X style={{ width: '16px', height: '16px' }} />
//                     </button>
                    
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                       <div style={{ position: 'relative' }}>
//                         <label style={styles.label}>Select Product Description</label>
//                         <input
//                           value={item.productName}
//                           onChange={e => updateLineField(item.id, 'productName', e.target.value)}
//                           onFocus={() => setShowProductDrop(item.id)}
//                           onBlur={() => setTimeout(() => setShowProductDrop(null), 250)}
//                           placeholder="Item description..."
//                           style={styles.input}
//                         />
//                         {showProductDrop === item.id && (
//                           <div style={styles.dropdownContainer}>
//                             {PRODUCTS.filter(p => p.name.toLowerCase().includes(item.productName.toLowerCase())).map(p => (
//                               <button
//                                 key={p.code}
//                                 type="button"
//                                 onMouseDown={() => selectProduct(item.id, p)}
//                                 style={styles.dropdownRowBtn}
//                               >
//                                 <div style={{ fontWeight: '600', color: '#404040', fontSize: '12px' }}>{p.name}</div>
//                                 <div style={{ color: '#a3a3a3', fontSize: '10px' }}>Rate: ₹{p.rate} | GST: {p.gst}%</div>
//                               </button>
//                             ))}
//                           </div>
//                         )}
//                       </div>

//                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
//                         <div>
//                           <label style={styles.label}>Qty</label>
//                           <input type="number" min={1} value={item.qty || ''} onChange={e => updateLineField(item.id, 'qty', parseInt(e.target.value) || 0)} style={styles.input} />
//                         </div>
//                         <div>
//                           <label style={styles.label}>Rate (₹)</label>
//                           <input type="number" min={0} value={item.rate || ''} onChange={e => updateLineField(item.id, 'rate', parseFloat(e.target.value) || 0)} style={styles.input} />
//                         </div>
//                       </div>

//                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
//                         <div>
//                           <label style={styles.label}>Disc %</label>
//                           <input type="number" min={0} max={100} value={item.discount || ''} onChange={e => updateLineField(item.id, 'discount', parseFloat(e.target.value) || 0)} style={styles.input} />
//                         </div>
//                         <div>
//                           <label style={styles.label}>Select GST</label>
//                           <select value={item.gstRate} onChange={e => updateLineField(item.id, 'gstRate', parseInt(e.target.value) || 0)} style={styles.input}>
//                             <option value={0}>0%</option>
//                             <option value={5}>5%</option>
//                             <option value={12}>12%</option>
//                             <option value={18}>18%</option>
//                             <option value={28}>28%</option>
//                           </select>
//                         </div>
//                       </div>

//                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#eff6ff', borderRadius: '8px', padding: '8px 12px' }}>
//                         <span style={{ fontSize: '12px', fontWeight: '600', color: '#1d4ed8' }}>Amount</span>
//                         <span style={{ fontSize: '14px', color: '#1e40af', fontWeight: '500' }}>₹{item.amount.toFixed(2)}</span>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
                
//                 <button
//                   type="button"
//                   onClick={addLine}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '8px',
//                     padding: '10px 0',
//                     border: '2px dashed #d4d4d4',
//                     borderRadius: '12px',
//                     fontSize: '14px',
//                     color: '#737373',
//                     backgroundColor: 'transparent',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   <Plus style={{ width: '16px', height: '16px' }} />
//                   Add Item
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Notes Card */}
//           <div style={styles.card}>
//             <div style={styles.cardHeader}>
//               <FileText style={{ width: '16px', height: '16px', color: '#a3a3a3' }} />
//               <h2 style={styles.cardTitle}>Notes & Remarks</h2>
//             </div>
//             <textarea
//               rows={3}
//               value={notes}
//               onChange={e => setNotes(e.target.value)}
//               placeholder="Internal notes, delivery instructions, or special remarks..."
//               style={styles.textarea}
//             />
//           </div>
//         </div>

//         {/* Right: Summary Sidebar */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

//           {/* Order Summary Card */}
//           <div style={{ ...styles.card, position: !isTabletOrMobile ? 'sticky' : 'static', top: '24px' }}>
//             <h2 style={{ ...styles.cardTitle, marginBottom: '16px' }}>Total Amount Summary</h2>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#525252' }}>
//                 <span>Subtotal Items ({items.length})</span>
//                 <span style={{ fontWeight: '500', color: '#262626' }}>₹{subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#525252' }}>
//                 <span>Total GST Tax Breakdown</span>
//                 <span style={{ fontWeight: '500', color: '#262626' }}>₹{gstAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//               <div style={{ borderTop: '1px solid #f5f5f5', paddingTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
//                 <span style={{ fontSize: '14px', fontWeight: '600', color: '#171717' }}>Total Amount</span>
//                 <span style={{ fontSize: '16px', fontBold: '700', color: '#1d4ed8', fontWeight: '700' }}>₹{totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//             </div>

//             <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
//               <button style={{ ...styles.btnPrimary, width: '100%', padding: '10px 16px' }}>
//                 <ShoppingCart style={{ width: '16px', height: '16px' }} />
//                 Confirm Order
//               </button>
//               <button style={{ ...styles.btnSecondary, width: '100%', padding: '8px 16px' }}>
//                 <Save style={{ width: '16px', height: '16px' }} />
//                 Save as Draft
//               </button>
//             </div>
//           </div>

//           {/* Order Info Summary Card */}
//           <div style={styles.card}>
//             <h2 style={{ ...styles.cardTitle, marginBottom: '12px' }}>Order Info Summary</h2>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px', color: '#737373' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Order No #</span>
//                 <span style={{ fontWeight: '600', color: '#404040' }}>{saleNo}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Order Date</span>
//                 <span style={{ fontWeight: '600', color: '#404040' }}>{saleDate}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Delivery Date</span>
//                 <span style={{ fontWeight: '600', color: '#404040' }}>{deliveryDate || '—'}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <span>Status</span>
//                 <span style={{
//                   fontWeight: '600',
//                   padding: '2px 8px',
//                   borderRadius: '9999px',
//                   fontSize: '10px',
//                   backgroundColor: status === 'Confirmed' ? '#dcfce7' : status === 'Processing' ? '#dbeafe' : '#f5f5f5',
//                   color: status === 'Confirmed' ? '#15803d' : status === 'Processing' ? '#1d4ed8' : '#737373'
//                 }}>
//                   {status}
//                 </span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Salesperson</span>
//                 <span style={{ fontWeight: '600', color: '#404040' }}>{salesperson || '—'}</span>
//               </div>
//               {selectedCustomerId && (
//                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <span>Interested Customer</span>
//                   <span style={{ fontWeight: '600', color: '#404040' }}>
//                     {CUSTOMER_DATA.find(c => c.id === selectedCustomerId)?.name}
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default SalesOrders;



// import React, { useState, useEffect } from 'react';
// import {
//   Plus, ChevronDown, ShoppingCart, Building2,
//   Calendar, Hash, Save, X, Mail, Phone as PhoneIcon, Landmark,
//   User, MapPin, FileText, Tag
// } from 'lucide-react';

// const CUSTOMER_DATA = [
//   { id: '1', name: 'John Doe', email: 'john.doe@example.com', phone: '+91 98765 43210', gstin: '27AAAAA1111A1Z1', billingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001', shippingAddress: '123 Main St, Sector 4, Mumbai, MH, 400001' },
//   { id: '2', name: 'Acme Corp', email: 'billing@acme.com', phone: '+91 99999 88888', gstin: '07AAAAA2222B2Z2', billingAddress: 'Tech Park, Block B, New Delhi, DL, 110001', shippingAddress: 'Warehouse 4, Okhla Phase 3, New Delhi, DL, 110020' },
//   { id: '3', name: 'TechStart Inc', email: 'finance@techstart.io', phone: '+91 88888 77777', gstin: '29AAAAA3333C3Z3', billingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034', shippingAddress: 'MG Road, Kormangala, Bengaluru, KA, 560034' },
//   { id: '4', name: 'Global Inc', email: 'accounts@globalinc.com', phone: '+91 77777 66666', gstin: '33AAAAA4444D4Z4', billingAddress: 'Anna Salai, T Nagar, Chennai, TN, 600017', shippingAddress: 'Anna Salai, T Nagar, Chennai, TN, 600017' },
// ];

// const SALESPERSONS = ['Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Nair', 'Vivek Menon'];

// const PRODUCTS = [
//   { name: 'Teak Divine Noir Wood HZ', code: 'TK-001', hsn: '44079900', unit: 'SQM', rate: 2400, gst: 18 },
//   { name: 'Ash Dyed Velvet Grey', code: 'DY-005', hsn: '44079900', unit: 'SQM', rate: 1850, gst: 18 },
//   { name: 'Smoked Oak Premium', code: 'SM-003', hsn: '44079900', unit: 'SQM', rate: 3100, gst: 18 },
//   { name: 'Herringbone Classic', code: 'HB-002', hsn: '44071500', unit: 'SQM', rate: 2750, gst: 12 },
//   { name: 'Edgewood Natural', code: 'EW-007', hsn: '44071500', unit: 'SQM', rate: 1600, gst: 12 },
//   { name: 'Tan Wood Series Standard', code: 'TW-010', hsn: '44071500', unit: 'SQM', rate: 1200, gst: 12 },
// ];

// function createLine(id) {
//   return { id, productName: '', qty: 1, rate: 0, discount: 0, amount: 0, gstRate: 0 };
// }

// function calcAmount(qty, rate, discount) {
//   return parseFloat((qty * rate * (1 - discount / 100)).toFixed(2));
// }

// const SalesOrders = () => {
//   // Global Viewport Core Engine
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Structural Screen Breakpoints
//   const isMobile = windowWidth < 640;
//   const isTablet = windowWidth >= 640 && windowWidth < 1024;
//   const isDesktop = windowWidth >= 1024;

//   // Form Core App State
//   const [saleNo] = useState(`SO-${String(Date.now()).slice(-5)}`);
//   const [saleDate, setSaleDate] = useState(new Date().toISOString().split('T')[0]);
//   const [deliveryDate, setDeliveryDate] = useState('');
//   const [status, setStatus] = useState('Draft');
//   const [salesperson, setSalesperson] = useState('');
//   const [poReference, setPoReference] = useState('');
//   const [selectedCustomerId, setSelectedCustomerId] = useState('');
//   const [customerEmail, setCustomerEmail] = useState('');
//   const [customerPhone, setCustomerPhone] = useState('');
//   const [customerGstin, setCustomerGstin] = useState('');
//   const [billingAddress, setBillingAddress] = useState('');
//   const [shippingAddress, setShippingAddress] = useState('');
//   const [items, setItems] = useState([createLine(1)]);
//   const [showProductDrop, setShowProductDrop] = useState(null);
//   const [notes, setNotes] = useState('');

//   const handleCustomerChange = (id) => {
//     setSelectedCustomerId(id);
//     const client = CUSTOMER_DATA.find(c => c.id === id);
//     if (client) {
//       setCustomerEmail(client.email);
//       setCustomerPhone(client.phone);
//       setCustomerGstin(client.gstin);
//       setBillingAddress(client.billingAddress);
//       setShippingAddress(client.shippingAddress);
//     } else {
//       setCustomerEmail('');
//       setCustomerPhone('');
//       setCustomerGstin('');
//       setBillingAddress('');
//       setShippingAddress('');
//     }
//   };

//   const selectProduct = (lineId, product) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== lineId) return item;
//       return { 
//         ...item, 
//         productName: product.name, 
//         rate: product.rate, 
//         gstRate: product.gst,
//         amount: calcAmount(item.qty, product.rate, item.discount) 
//       };
//     }));
//     setShowProductDrop(null);
//   };

//   const updateLineField = (id, field, value) => {
//     setItems(prev => prev.map(item => {
//       if (item.id !== id) return item;
//       const updated = { ...item, [field]: value };
//       if (field === 'productName') {
//         const exactProd = PRODUCTS.find(p => p.name.toLowerCase() === value.toLowerCase());
//         if (exactProd) updated.gstRate = exactProd.gst;
//       }
//       updated.amount = calcAmount(updated.qty, updated.rate, updated.discount);
//       return updated;
//     }));
//   };

//   const addLine = () => {
//     const newId = items.length > 0 ? Math.max(...items.map(i => i.id)) + 1 : 1;
//     setItems(prev => [...prev, createLine(newId)]);
//   };

//   const removeLine = (id) => {
//     if (items.length === 1) return;
//     setItems(prev => prev.filter(i => i.id !== id));
//   };

//   const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
//   const gstAmount = items.reduce((sum, item) => sum + (item.amount * (item.gstRate / 100)), 0);
//   const totalAmount = subtotal + gstAmount;

//   // Precision Adaptive Inline Structural Style Dictionary
//   const styles = {
//     screenWrapper: {
//       padding: isMobile ? '12px' : isTablet ? '24px' : '32px',
//       maxWidth: '1280px',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       backgroundColor: '#fafafa',
//       minHeight: '100vh',
//       fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//       boxSizing: 'border-box'
//     },
//     headerPanel: {
//       display: 'flex',
//       flexDirection: isMobile ? 'column' : 'row',
//       alignItems: isMobile ? 'flex-start' : 'center',
//       justifyContent: 'between',
//       gap: '16px',
//       borderBottom: '1px solid #f0f0f0',
//       paddingBottom: '20px',
//       marginBottom: '24px'
//     },
//     actionHeaderButtons: {
//       display: 'flex',
//       gap: '10px',
//       width: isMobile ? '100%' : 'auto',
//       marginLeft: isMobile ? '0' : 'auto'
//     },
//     mainLayoutGrid: {
//       display: 'grid',
//       gridTemplateColumns: isDesktop ? '2fr 1fr' : '1fr',
//       gap: isMobile ? '16px' : '24px',
//       alignItems: 'start'
//     },
//     formBlockContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: isMobile ? '16px' : '24px'
//     },
//     cardLayout: {
//       backgroundColor: '#ffffff',
//       border: '1px solid #eef0f2',
//       borderRadius: isMobile ? '12px' : '16px',
//       padding: isMobile ? '16px' : '24px',
//       boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.02)'
//     },
//     cardHeadRow: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '10px',
//       marginBottom: '20px'
//     },
//     cardHeadingTitle: {
//       color: '#1a1a1a',
//       fontWeight: '600',
//       fontSize: '13px',
//       textTransform: 'uppercase',
//       letterSpacing: '0.06em',
//       margin: 0
//     },
//     adaptiveGrid2: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//       gap: '16px'
//     },
//     adaptiveGrid3: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr 1fr' : '1fr 1fr 1fr',
//       gap: '16px'
//     },
//     fieldLabel: {
//       display: 'block',
//       fontSize: '11px',
//       fontWeight: '600',
//       color: '#6b7280',
//       textTransform: 'uppercase',
//       letterSpacing: '0.04em',
//       marginBottom: '6px'
//     },
//     inputElementContainer: {
//       position: 'relative',
//       width: '100%'
//     },
//     inputInlineIcon: {
//       position: 'absolute',
//       left: '12px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: '15px',
//       height: '15px',
//       color: '#9ca3af',
//       pointerEvents: 'none'
//     },
//     standardInput: {
//       width: '100%',
//       padding: '10px 14px',
//       fontSize: '14px',
//       backgroundColor: '#f9fafb',
//       border: '1px solid #e5e7eb',
//       borderRadius: '10px',
//       outline: 'none',
//       boxSizing: 'border-box',
//       transition: 'all 0.15s ease'
//     },
//     iconicInput: {
//       width: '100%',
//       padding: '10px 14px 10px 38px',
//       fontSize: '14px',
//       backgroundColor: '#f9fafb',
//       border: '1px solid #e5e7eb',
//       borderRadius: '10px',
//       outline: 'none',
//       boxSizing: 'border-box'
//     },
//     iconicSelect: {
//       width: '100%',
//       padding: '10px 36px 10px 38px',
//       fontSize: '14px',
//       backgroundColor: '#f9fafb',
//       border: '1px solid #e5e7eb',
//       borderRadius: '10px',
//       outline: 'none',
//       appearance: 'none',
//       boxSizing: 'border-box'
//     },
//     customSelectChevron: {
//       position: 'absolute',
//       right: '12px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: '15px',
//       height: '15px',
//       color: '#9ca3af',
//       pointerEvents: 'none'
//     },
//     segmentedControlBar: {
//       display: 'flex',
//       backgroundColor: '#f3f4f6',
//       padding: '4px',
//       borderRadius: '10px',
//       gap: '4px'
//     },
//     segmentedControlButton: (currentValue, targetValue) => ({
//       flex: 1,
//       padding: '8px 0',
//       fontSize: '12px',
//       fontWeight: '500',
//       borderRadius: '7px',
//       border: 'none',
//       cursor: 'pointer',
//       backgroundColor: currentValue === targetValue ? '#ffffff' : 'transparent',
//       color: currentValue === targetValue ? '#111827' : '#4b5563',
//       boxShadow: currentValue === targetValue ? '0 1px 3px rgba(0,0,0,0.06)' : 'none',
//       border: currentValue === targetValue ? '1px solid #e5e7eb' : '1px solid transparent'
//     }),
//     customTextAreaLayout: {
//       width: '100%',
//       padding: '10px 14px',
//       fontSize: '14px',
//       backgroundColor: '#f9fafb',
//       border: '1px solid #e5e7eb',
//       borderRadius: '10px',
//       outline: 'none',
//       resize: 'none',
//       boxSizing: 'border-box'
//     },
//     tableHeadCellStyles: (align, specifiedWidth) => ({
//       textAlign: align,
//       paddingBottom: '10px',
//       fontWeight: '600',
//       fontSize: '11px',
//       color: '#6b7280',
//       textTransform: 'uppercase',
//       letterSpacing: '0.05em',
//       width: specifiedWidth || 'auto'
//     }),
//     dropdownSelectionContainer: {
//       position: 'absolute',
//       zIndex: 100,
//       left: 0,
//       top: '100%',
//       marginTop: '4px',
//       width: '100%',
//       backgroundColor: '#ffffff',
//       border: '1px solid #e5e7eb',
//       borderRadius: '10px',
//       boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
//       maxHeight: '180px',
//       overflowY: 'auto'
//     },
//     dropdownItemRow: {
//       width: '100%',
//       textAlign: 'left',
//       padding: '10px 14px',
//       backgroundColor: 'transparent',
//       border: 'none',
//       borderBottom: '1px solid #f3f4f6',
//       cursor: 'pointer',
//       boxSizing: 'border-box'
//     },
//     actionPrimaryBtn: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       padding: '10px 18px',
//       backgroundColor: '#2563eb',
//       color: '#ffffff',
//       borderRadius: '10px',
//       border: 'none',
//       fontSize: '14px',
//       fontWeight: '500',
//       cursor: 'pointer',
//       flex: isMobile ? 1 : 'none'
//     },
//     actionSecondaryBtn: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       padding: '10px 18px',
//       backgroundColor: '#ffffff',
//       color: '#374151',
//       borderRadius: '10px',
//       border: '1px solid #d1d5db',
//       fontSize: '14px',
//       fontWeight: '500',
//       cursor: 'pointer',
//       flex: isMobile ? 1 : 'none'
//     },
//     stickySidebar: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '16px',
//       position: isDesktop ? 'sticky' : 'static',
//       top: '24px'
//     }
//   };

//   return (
//     <div style={styles.screenWrapper}>
//       {/* Dynamic Header */}
//       <div style={styles.headerPanel}>
//         <div>
//           <h1 style={{ fontSize: isMobile ? '18px' : '22px', fontWeight: '700', color: '#111827', margin: 0 }}>Sales Orders</h1>
//           <p style={{ color: '#4b5563', fontSize: '13px', margin: '4px 0 0 0' }}>Create and manage customer sales orders</p>
//         </div>
//         <div style={styles.actionHeaderButtons}>
//           <button style={styles.actionSecondaryBtn}>
//             <Save style={{ width: '15px', height: '15px' }} />
//             Save Draft
//           </button>
//           <button style={styles.actionPrimaryBtn}>
//             <ShoppingCart style={{ width: '15px', height: '15px' }} />
//             Confirm Order
//           </button>
//         </div>
//       </div>

//       <div style={styles.mainLayoutGrid}>
//         {/* Core Operational Form Panels */}
//         <div style={styles.formBlockContainer}>

//           {/* Block 1: Metadata Fields */}
//           <div style={styles.cardLayout}>
//             <div style={styles.cardHeadRow}>
//               <ShoppingCart style={{ width: '16px', height: '16px', color: '#2563eb' }} />
//               <h2 style={styles.cardHeadingTitle}>Sale Order Details</h2>
//             </div>

//             <div style={styles.adaptiveGrid2}>
//               <div>
//                 <label style={styles.fieldLabel}>Order Number</label>
//                 <div style={styles.inputElementContainer}>
//                   <Hash style={styles.inputInlineIcon} />
//                   <input 
//                     value={saleNo} 
//                     readOnly 
//                     style={{ ...styles.iconicInput, backgroundColor: '#f3f4f6', cursor: 'not-allowed', color: '#6b7280' }} 
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.fieldLabel}>Order Date</label>
//                 <div style={styles.inputElementContainer}>
//                   <Calendar style={styles.inputInlineIcon} />
//                   <input
//                     type="date"
//                     value={saleDate}
//                     onChange={e => setSaleDate(e.target.value)}
//                     style={styles.iconicInput}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.fieldLabel}>Delivery Date</label>
//                 <div style={styles.inputElementContainer}>
//                   <Calendar style={styles.inputInlineIcon} />
//                   <input
//                     type="date"
//                     value={deliveryDate}
//                     onChange={e => setDeliveryDate(e.target.value)}
//                     style={styles.iconicInput}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.fieldLabel}>Status</label>
//                 <div style={styles.segmentedControlBar}>
//                   {['Draft', 'Confirmed', 'Processing'].map(s => (
//                     <button
//                       key={s}
//                       type="button"
//                       onClick={() => setStatus(s)}
//                       style={styles.segmentedControlButton(status, s)}
//                     >
//                       {s}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.fieldLabel}>Salesperson</label>
//                 <div style={styles.inputElementContainer}>
//                   <User style={styles.inputInlineIcon} />
//                   <select
//                     value={salesperson}
//                     onChange={e => setSalesperson(e.target.value)}
//                     style={styles.iconicSelect}
//                   >
//                     <option value="">-- Assign Salesperson --</option>
//                     {SALESPERSONS.map(s => <option key={s}>{s}</option>)}
//                   </select>
//                   <ChevronDown style={styles.customSelectChevron} />
//                 </div>
//               </div>

//               <div>
//                 <label style={styles.fieldLabel}>PO / Reference No.</label>
//                 <div style={styles.inputElementContainer}>
//                   <Tag style={styles.inputInlineIcon} />
//                   <input
//                     value={poReference}
//                     onChange={e => setPoReference(e.target.value)}
//                     placeholder="Customer PO number"
//                     style={styles.iconicInput}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Block 2: CRM Profiles */}
//           <div style={styles.cardLayout}>
//             <div style={styles.cardHeadRow}>
//               <Building2 style={{ width: '16px', height: '16px', color: '#7c3aed' }} />
//               <h2 style={styles.cardHeadingTitle}>Customer Info</h2>
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//               <div>
//                 <label style={styles.fieldLabel}>Select Interested Customer</label>
//                 <div style={styles.inputElementContainer}>
//                   <select
//                     value={selectedCustomerId}
//                     onChange={e => handleCustomerChange(e.target.value)}
//                     style={{ ...styles.standardInput, paddingRight: '36px', appearance: 'none' }}
//                   >
//                     <option value="">-- Select Customer --</option>
//                     {CUSTOMER_DATA.map(c => (
//                       <option key={c.id} value={c.id}>{c.name}</option>
//                     ))}
//                   </select>
//                   <ChevronDown style={styles.customSelectChevron} />
//                 </div>
//               </div>

//               <div style={styles.adaptiveGrid3}>
//                 <div>
//                   <label style={styles.fieldLabel}>Email</label>
//                   <div style={styles.inputElementContainer}>
//                     <Mail style={styles.inputInlineIcon} />
//                     <input
//                       type="email"
//                       value={customerEmail}
//                       onChange={e => setCustomerEmail(e.target.value)}
//                       placeholder="email@example.com"
//                       style={styles.iconicInput}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={styles.fieldLabel}>Phone</label>
//                   <div style={styles.inputElementContainer}>
//                     <PhoneIcon style={styles.inputInlineIcon} />
//                     <input
//                       type="text"
//                       value={customerPhone}
//                       onChange={e => setCustomerPhone(e.target.value)}
//                       placeholder="Phone number"
//                       style={styles.iconicInput}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={styles.fieldLabel}>GSTIN</label>
//                   <div style={styles.inputElementContainer}>
//                     <Landmark style={styles.inputInlineIcon} />
//                     <input
//                       type="text"
//                       value={customerGstin}
//                       onChange={e => setCustomerGstin(e.target.value)}
//                       placeholder="GSTIN reference"
//                       style={styles.iconicInput}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.adaptiveGrid2}>
//                 <div>
//                   <label style={styles.fieldLabel}>
//                     <MapPin style={{ display: 'inline', width: '12px', height: '12px', marginRight: '4px', verticalAlign: 'middle' }} />
//                     Billing Address
//                   </label>
//                   <textarea
//                     rows={2}
//                     value={billingAddress}
//                     onChange={e => setBillingAddress(e.target.value)}
//                     placeholder="Enter billing address"
//                     style={styles.customTextAreaLayout}
//                   />
//                 </div>
//                 <div>
//                   <label style={styles.fieldLabel}>
//                     <MapPin style={{ display: 'inline', width: '12px', height: '12px', marginRight: '4px', verticalAlign: 'middle' }} />
//                     Shipping / Delivery Address
//                   </label>
//                   <textarea
//                     rows={2}
//                     value={shippingAddress}
//                     onChange={e => setShippingAddress(e.target.value)}
//                     placeholder="Enter delivery address"
//                     style={styles.customTextAreaLayout}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Block 3: Dynamic Itemized Matrix Selector */}
//           <div style={styles.cardLayout}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//               <h2 style={styles.cardHeadingTitle}>Order Items</h2>
//               {!isMobile && (
//                 <button
//                   type="button"
//                   onClick={addLine}
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '6px',
//                     padding: '6px 12px',
//                     backgroundColor: '#eff6ff',
//                     color: '#2563eb',
//                     borderRadius: '8px',
//                     border: '1px solid #bfdbfe',
//                     fontSize: '12px',
//                     fontWeight: '500',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   <Plus style={{ width: '14px', height: '14px' }} />
//                   Add Item
//                 </button>
//               )}
//             </div>

//             {/* Matrix Desktop/Tablet Layer Viewport */}
//             {!isMobile && (
//               <div style={{ overflowX: 'auto' }}>
//                 <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse', minWidth: '600px' }}>
//                   <thead>
//                     <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
//                       <th style={styles.tableHeadCellStyles('left', '35%')}>Select Product Description</th>
//                       <th style={styles.tableHeadCellStyles('center', '10%')}>Qty</th>
//                       <th style={styles.tableHeadCellStyles('right', '15%')}>Rate (₹)</th>
//                       <th style={styles.tableHeadCellStyles('center', '12%')}>Disc %</th>
//                       <th style={styles.tableHeadCellStyles('left', '13%')}>Select GST</th>
//                       <th style={styles.tableHeadCellStyles('right', '12%')}>Amount</th>
//                       <th style={styles.tableHeadCellStyles('center', '3%')} />
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {items.map(item => (
//                       <tr key={item.id} style={{ borderBottom: '1px solid #f9fafb' }}>
//                         <td style={{ padding: '10px 6px 10px 0', position: 'relative' }}>
//                           <input
//                             value={item.productName}
//                             onChange={e => updateLineField(item.id, 'productName', e.target.value)}
//                             onFocus={() => setShowProductDrop(item.id)}
//                             onBlur={() => setTimeout(() => setShowProductDrop(null), 250)}
//                             placeholder="Type item description..."
//                             style={styles.standardInput}
//                           />
//                           {showProductDrop === item.id && (
//                             <div style={styles.dropdownSelectionContainer}>
//                               {PRODUCTS.filter(p => p.name.toLowerCase().includes(item.productName.toLowerCase())).map(p => (
//                                 <button
//                                   key={p.code}
//                                   type="button"
//                                   onMouseDown={() => selectProduct(item.id, p)}
//                                   style={styles.dropdownItemRow}
//                                 >
//                                   <div style={{ fontWeight: '600', color: '#374151', fontSize: '12px' }}>{p.name}</div>
//                                   <div style={{ color: '#9ca3af', fontSize: '10px', marginTop: '2px' }}>Rate: ₹{p.rate} | Unit: {p.unit} | GST: {p.gst}%</div>
//                                 </button>
//                               ))}
//                             </div>
//                           )}
//                         </td>
//                         <td style={{ padding: '10px 6px' }}>
//                           <input
//                             type="number"
//                             min={1}
//                             value={item.qty || ''}
//                             onChange={e => updateLineField(item.id, 'qty', parseInt(e.target.value) || 0)}
//                             style={{ ...styles.standardInput, textAlign: 'center' }}
//                           />
//                         </td>
//                         <td style={{ padding: '10px 6px' }}>
//                           <input
//                             type="number"
//                             min={0}
//                             value={item.rate || ''}
//                             onChange={e => updateLineField(item.id, 'rate', parseFloat(e.target.value) || 0)}
//                             style={{ ...styles.standardInput, textAlign: 'right' }}
//                           />
//                         </td>
//                         <td style={{ padding: '10px 6px' }}>
//                           <input
//                             type="number"
//                             min={0}
//                             max={100}
//                             value={item.discount || ''}
//                             onChange={e => updateLineField(item.id, 'discount', parseFloat(e.target.value) || 0)}
//                             style={{ ...styles.standardInput, textAlign: 'center' }}
//                           />
//                         </td>
//                         <td style={{ padding: '10px 6px' }}>
//                           <select
//                             value={item.gstRate}
//                             onChange={e => updateLineField(item.id, 'gstRate', parseInt(e.target.value) || 0)}
//                             style={styles.standardInput}
//                           >
//                             <option value={0}>0%</option>
//                             <option value={5}>5%</option>
//                             <option value={12}>12%</option>
//                             <option value={18}>18%</option>
//                             <option value={28}>28%</option>
//                           </select>
//                         </td>
//                         <td style={{ padding: '10px 6px', textAlign: 'right', fontWeight: '600', color: '#1f2937' }}>
//                           ₹{item.amount.toFixed(2)}
//                         </td>
//                         <td style={{ padding: '10px 0 10px 6px', textAlign: 'center' }}>
//                           <button
//                             type="button"
//                             onClick={() => removeLine(item.id)}
//                             disabled={items.length === 1}
//                             style={{
//                               padding: '6px',
//                               border: 'none',
//                               backgroundColor: 'transparent',
//                               color: '#ef4444',
//                               cursor: items.length === 1 ? 'not-allowed' : 'pointer',
//                               opacity: items.length === 1 ? 0.25 : 0.8
//                             }}
//                           >
//                             <X style={{ width: '15px', height: '15px' }} />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             {/* Optimized High-Fidelity Mobile Card List */}
//             {isMobile && (
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
//                 {items.map(item => (
//                   <div key={item.id} style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '14px', position: 'relative', backgroundColor: '#f9fafb' }}>
//                     <button
//                       type="button"
//                       onClick={() => removeLine(item.id)}
//                       disabled={items.length === 1}
//                       style={{ position: 'absolute', top: '10px', right: '10px', border: 'none', backgroundColor: 'transparent', color: '#9ca3af', opacity: items.length === 1 ? 0.3 : 1 }}
//                     >
//                       <X style={{ width: '16px', height: '16px' }} />
//                     </button>
                    
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                       <div style={{ position: 'relative' }}>
//                         <label style={styles.fieldLabel}>Select Product Description</label>
//                         <input
//                           value={item.productName}
//                           onChange={e => updateLineField(item.id, 'productName', e.target.value)}
//                           onFocus={() => setShowProductDrop(item.id)}
//                           onBlur={() => setTimeout(() => setShowProductDrop(null), 250)}
//                           placeholder="Item description..."
//                           style={styles.standardInput}
//                         />
//                         {showProductDrop === item.id && (
//                           <div style={styles.dropdownSelectionContainer}>
//                             {PRODUCTS.filter(p => p.name.toLowerCase().includes(item.productName.toLowerCase())).map(p => (
//                               <button
//                                 key={p.code}
//                                 type="button"
//                                 onMouseDown={() => selectProduct(item.id, p)}
//                                 style={styles.dropdownItemRow}
//                               >
//                                 <div style={{ fontWeight: '600', color: '#374151', fontSize: '12px' }}>{p.name}</div>
//                                 <div style={{ color: '#9ca3af', fontSize: '10px' }}>Rate: ₹{p.rate} | GST: {p.gst}%</div>
//                               </button>
//                             ))}
//                           </div>
//                         )}
//                       </div>

//                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
//                         <div>
//                           <label style={styles.fieldLabel}>Qty</label>
//                           <input type="number" min={1} value={item.qty || ''} onChange={e => updateLineField(item.id, 'qty', parseInt(e.target.value) || 0)} style={styles.standardInput} />
//                         </div>
//                         <div>
//                           <label style={styles.fieldLabel}>Rate (₹)</label>
//                           <input type="number" min={0} value={item.rate || ''} onChange={e => updateLineField(item.id, 'rate', parseFloat(e.target.value) || 0)} style={styles.standardInput} />
//                         </div>
//                       </div>

//                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
//                         <div>
//                           <label style={styles.fieldLabel}>Disc %</label>
//                           <input type="number" min={0} max={100} value={item.discount || ''} onChange={e => updateLineField(item.id, 'discount', parseFloat(e.target.value) || 0)} style={styles.standardInput} />
//                         </div>
//                         <div>
//                           <label style={styles.fieldLabel}>Select GST</label>
//                           <select value={item.gstRate} onChange={e => updateLineField(item.id, 'gstRate', parseInt(e.target.value) || 0)} style={styles.standardInput}>
//                             <option value={0}>0%</option>
//                             <option value={5}>5%</option>
//                             <option value={12}>12%</option>
//                             <option value={18}>18%</option>
//                             <option value={28}>28%</option>
//                           </select>
//                         </div>
//                       </div>

//                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#eff6ff', borderRadius: '8px', padding: '10px 14px', marginTop: '4px' }}>
//                         <span style={{ fontSize: '12px', fontWeight: '600', color: '#1d4ed8' }}>Line Total</span>
//                         <span style={{ fontSize: '14px', color: '#1e40af', fontWeight: '600' }}>₹{item.amount.toFixed(2)}</span>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
                
//                 <button
//                   type="button"
//                   onClick={addLine}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '8px',
//                     padding: '12px 0',
//                     border: '2px dashed #d1d5db',
//                     borderRadius: '12px',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     color: '#4b5563',
//                     backgroundColor: 'transparent',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   <Plus style={{ width: '16px', height: '16px' }} />
//                   Add New Line Item
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Block 4: Context Remarks */}
//           <div style={styles.cardLayout}>
//             <div style={styles.cardHeadRow}>
//               <FileText style={{ width: '16px', height: '16px', color: '#9ca3af' }} />
//               <h2 style={styles.cardHeadingTitle}>Notes & Remarks</h2>
//             </div>
//             <textarea
//               rows={3}
//               value={notes}
//               onChange={e => setNotes(e.target.value)}
//               placeholder="Internal notes, delivery instructions, or special remarks..."
//               style={styles.customTextAreaLayout}
//             />
//           </div>
//         </div>

//         {/* Right Sidebar: Calculations Aggregate Engine */}
//         <div style={styles.stickySidebar}>

//           {/* Aggregate Calculation Summary */}
//           <div style={styles.cardLayout}>
//             <h2 style={{ ...styles.cardHeadingTitle, marginBottom: '16px' }}>Total Amount Summary</h2>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#4b5563' }}>
//                 <span>Subtotal ({items.length} items)</span>
//                 <span style={{ fontWeight: '500', color: '#111827' }}>₹{subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#4b5563' }}>
//                 <span>Aggregate GST Duty</span>
//                 <span style={{ fontWeight: '500', color: '#111827' }}>₹{gstAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//               <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <span style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>Total Pay Amount</span>
//                 <span style={{ fontSize: '18px', color: '#2563eb', fontWeight: '700' }}>₹{totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
//               </div>
//             </div>

//             <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
//               <button style={{ ...styles.actionPrimaryBtn, width: '100%', padding: '12px' }}>
//                 <ShoppingCart style={{ width: '16px', height: '16px' }} />
//                 Confirm Order Securely
//               </button>
//               <button style={{ ...styles.actionSecondaryBtn, width: '100%', padding: '10px' }}>
//                 <Save style={{ width: '16px', height: '16px' }} />
//                 Save Blueprint Draft
//               </button>
//             </div>
//           </div>

//           {/* Audit Trail Context Profile */}
//           <div style={styles.cardLayout}>
//             <h2 style={{ ...styles.cardHeadingTitle, marginBottom: '14px' }}>Order Info Summary</h2>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '12px', color: '#6b7280' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Order Identifier</span>
//                 <span style={{ fontWeight: '600', color: '#374151' }}>{saleNo}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>System Creation Date</span>
//                 <span style={{ fontWeight: '600', color: '#374151' }}>{saleDate}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Target Delivery Date</span>
//                 <span style={{ fontWeight: '600', color: '#374151' }}>{deliveryDate || '—'}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <span>Workflow Status</span>
//                 <span style={{
//                   fontWeight: '600',
//                   padding: '3px 10px',
//                   borderRadius: '9999px',
//                   fontSize: '10px',
//                   backgroundColor: status === 'Confirmed' ? '#dcfce7' : status === 'Processing' ? '#dbeafe' : '#f3f4f6',
//                   color: status === 'Confirmed' ? '#166534' : status === 'Processing' ? '#1e40af' : '#4b5563'
//                 }}>
//                   {status}
//                 </span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <span>Assigned Agent</span>
//                 <span style={{ fontWeight: '600', color: '#374151' }}>{salesperson || '—'}</span>
//               </div>
//               {selectedCustomerId && (
//                 <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px dashed #f3f4f6', paddingTop: '8px', marginTop: '2px' }}>
//                   <span>Linked Client</span>
//                   <span style={{ fontWeight: '600', color: '#374151' }}>
//                     {CUSTOMER_DATA.find(c => c.id === selectedCustomerId)?.name}
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default SalesOrders;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  Plus, ChevronDown, ShoppingCart, Building2,
  Calendar, Hash, Save, Trash2, Mail, Phone, Landmark,
  FileText, Tag, Percent
} from 'lucide-react';

const SalesOrders = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Screen layout breakpoints tracking state
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth >= 640 && windowWidth < 1024;
  const isDesktop = windowWidth >= 1024;

  const fetchOrderById = async (orderId) => {
    try {
      const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${orderId}`);
      const order = res.data;
      const items = typeof order.items === "string" ? JSON.parse(order.items) : order.items;
      setNewOrder({ ...order, items });
    } catch (err) {
      console.error("Error fetching order:", err);
      alert("❌ Failed to load order details");
    }
  };

  useEffect(() => {
    if (id) fetchOrderById(id);
  }, [id]);

  // --- Order form state
  const [newOrder, setNewOrder] = useState({
    order_number: "",
    customer_id: "",
    customer_name: "",
    order_date: "",
    gst: "",
    gst_amount: 0,
    discount: '',
    total_amount: 0,
    shipping_address: "",
    items: [],
    notes: "",
    user_id: "",
  });

  const [newItem, setNewItem] = useState({
    product_name: "",
    thickness: "",
    grade: "",
    size: "",
    quantity: "",
    unit_price: "",
  });

  const [gstEntries, setGstEntries] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);

  // Fetch GST list
  useEffect(() => {
    const fetchGst = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem("userData"));
        if (!user?.id) return;
        const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/api/gst", {
          headers: { "x-user-id": user.id },
        });
        setGstEntries(res.data);
      } catch (err) {
        console.error("Error fetching GST entries:", err);
      }
    };
    fetchGst();
  }, []);

  // Fetch interested customers
  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem("userData"));
        if (!user?.id) return;
        const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/lead_management", {
          params: { user_id: user.id },
        });
        setCustomers(res.data.filter((c) => c.status === "INTERESTED"));
      } catch (err) {
        console.error("Error fetching leads:", err);
      }
    };
    fetchLeads();
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem("userData"));
        if (!user?.id) return;
        const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/ordersapi?user_id=${user.id}`);
        setProducts(res.data);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "discount" || name === "gst") {
      updatedValue = value;
      calculateTotal(newOrder.items, name === "discount" ? Number(value) : newOrder.discount, name === "gst" ? value : newOrder.gst);
    }

    setNewOrder((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  // Handle adding item
  const handleItemChange = (e) => {
    const { name, value } = e.target;
    if (name === "product_name") {
      const selectedProduct = products.find((p) => p.name === value);
      if (selectedProduct) {
        setNewItem({
          product_name: selectedProduct.name,
          thickness: selectedProduct.thickness || "",
          grade: selectedProduct.grade || "",
          size: selectedProduct.size || "",
          unit_price: selectedProduct.price || "",
          quantity: "",
        });
      }
    } else {
      setNewItem((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Add item to order
  const handleAddItem = (e) => {
    e.preventDefault();
    if (!newItem.product_name || !newItem.quantity || !newItem.unit_price) {
      alert("Please fill all item fields");
      return;
    }
    const updatedItems = [
      ...newOrder.items,
      {
        product_name: newItem.product_name,
        thickness: newItem.thickness || "",
        grade: newItem.grade || "",
        size: newItem.size || "",
        quantity: Number(newItem.quantity),
        unit_price: Number(newItem.unit_price),
      },
    ];
    calculateTotal(updatedItems, newOrder.discount, newOrder.gst);
    setNewOrder((prev) => ({ ...prev, items: updatedItems }));
    setNewItem({ product_name: "", thickness: "", grade: "", size: "", quantity: "", unit_price: "" });
  };

  // Remove item
  const handleRemoveItem = (index) => {
    const updatedItems = newOrder.items.filter((_, i) => i !== index);
    calculateTotal(updatedItems, newOrder.discount, newOrder.gst);
    setNewOrder((prev) => ({ ...prev, items: updatedItems }));
  };

  // GST + Discount calculation
  const calculateTotal = (items, discount, gstValue) => {
    const subtotal = items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0);
    const discountAmount = (subtotal * (discount || 0)) / 100;

    let gstRate = 0;
    if (gstValue) {
      const match = gstValue.match(/(\d+(\.\d+)?)/);
      if (match) gstRate = parseFloat(match[0]);
    }

    const taxableAmount = subtotal - discountAmount;
    const gstAmount = (taxableAmount * gstRate) / 100;
    const total = taxableAmount + gstAmount;

    setNewOrder((prev) => ({
      ...prev,
      total_amount: total,
      gst_amount: gstAmount,
    }));
  };

  // Submit order
  const handleAddNewOrder = async (e) => {
    e.preventDefault();
    const user = JSON.parse(sessionStorage.getItem("userData"));
    if (!user?.id) {
      alert("User not logged in!");
      return;
    }

    if (!newOrder.customer_name || !newOrder.order_number) {
      alert("Please enter customer name and order number");
      return;
    }

    if (newOrder.items.length === 0) {
      alert("Please add at least one item");
      return;
    }

    try {
      if (id) {
        await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${id}`, newOrder);
        alert("✅ Order updated successfully!");
      } else {
        const orderData = { ...newOrder, user_id: user.id };
        await axios.post(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders`, orderData);
        alert("✅ Order added successfully!");
      }
      navigate("/dashboard/SalesOrderList");
      setNewOrder({
        order_number: "",
        customer_id: "",
        customer_name: "",
        order_date: "",
        gst: "",
        gst_amount: 0,
        discount: 0,
        total_amount: 0,
        shipping_address: "",
        items: [],
        notes: "",
        user_id: "",
      });
    } catch (err) {
      console.error("Error adding new order:", err);
      alert("Failed to save order");
    }
  };

  const currentSubtotal = newOrder.items.reduce((sum, item) => sum + item.quantity * item.unit_price, 0);

  // Precision Dynamic Inline Styles
  const styles = {
    screenContainer: {
      maxWidth: '1280px',
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: '#fafafa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      boxSizing: 'border-box'
    },
    headerPanel: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'flex-start' : 'center',
      justifyContent: 'space-between',
      gap: '16px',
      borderBottom: '1px solid #f0f0f0',
      paddingBottom: '20px',
      marginBottom: '24px'
    },
    mainLayoutGrid: {
      display: 'grid',
      gridTemplateColumns: isDesktop ? '2fr 1fr' : '1fr',
      gap: isMobile ? '16px' : '24px',
      alignItems: 'start'
    },
    formBlockContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: isMobile ? '16px' : '24px'
    },
    cardLayout: {
      backgroundColor: '#ffffff',
      border: '1px solid #eef0f2',
      borderRadius: isMobile ? '12px' : '16px',
      padding: isMobile ? '16px' : '24px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.02)'
    },
    cardHeadRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    cardHeadingTitle: {
      color: '#1a1a1a',
      fontWeight: '600',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      margin: 0
    },
    adaptiveGrid2: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: '16px'
    },
    fieldLabel: {
      display: 'block',
      fontSize: '11px',
      fontWeight: '600',
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      marginBottom: '6px'
    },
    inputElementContainer: {
      position: 'relative',
      width: '100%'
    },
    inputInlineIcon: {
      position: 'absolute',
      left: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '15px',
      height: '15px',
      color: '#9ca3af',
      pointerEvents: 'none'
    },
    standardInput: {
      width: '100%',
      padding: '10px 14px',
      fontSize: '14px',
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      outline: 'none',
      boxSizing: 'border-box'
    },
    iconicInput: {
      width: '100%',
      padding: '10px 14px 10px 38px',
      fontSize: '14px',
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      outline: 'none',
      boxSizing: 'border-box'
    },
    iconicSelect: {
      width: '100%',
      padding: '10px 36px 10px 38px',
      fontSize: '14px',
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      outline: 'none',
      appearance: 'none',
      boxSizing: 'border-box'
    },
    customSelectChevron: {
      position: 'absolute',
      right: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '15px',
      height: '15px',
      color: '#9ca3af',
      pointerEvents: 'none'
    },
    customTextAreaLayout: {
      width: '100%',
      padding: '10px 14px',
      fontSize: '14px',
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      outline: 'none',
      resize: 'none',
      boxSizing: 'border-box'
    },
    tableHeadCellStyles: (align, specifiedWidth) => ({
      textAlign: align,
      paddingBottom: '10px',
      fontWeight: '600',
      fontSize: '11px',
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      width: specifiedWidth || 'auto'
    }),
    actionPrimaryBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      padding: '10px 18px',
      backgroundColor: '#16a34a',
      color: '#ffffff',
      borderRadius: '10px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      width: '100%'
    },
    actionSecondaryBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      padding: '8px 14px',
      backgroundColor: '#059669',
      color: '#ffffff',
      borderRadius: '8px',
      border: 'none',
      fontSize: '13px',
      fontWeight: '500',
      cursor: 'pointer'
    },
    stickySidebar: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      position: isDesktop ? 'sticky' : 'static',
      top: '24px'
    }
  };

  return (
    <div style={styles.screenContainer}>
      {/* Page Header */}
      <div style={styles.headerPanel}>
        <div>
          <h1 style={{ fontSize: isMobile ? '18px' : '22px', fontWeight: '700', color: '#111827', margin: 0 }}>
            Sales Orders Management
          </h1>
          <p style={{ color: '#4b5563', fontSize: '13px', margin: '4px 0 0 0' }}>
            {id ? "Modify existing sales order matrix parameters" : "Generate and map client business records"}
          </p>
        </div>
      </div>

      <div style={styles.mainLayoutGrid}>
        {/* Left Column: Form Setup */}
        <div style={styles.formBlockContainer}>
          
          {/* Section 1: Sales Context Identity */}
          <div style={styles.cardLayout}>
            <div style={styles.cardHeadRow}>
              <ShoppingCart style={{ width: '16px', height: '16px', color: '#2563eb' }} />
              <h2 style={styles.cardHeadingTitle}>Sales Context Details</h2>
            </div>

            <div style={styles.adaptiveGrid2}>
              <div>
                <label style={styles.fieldLabel}>Order Identifier #</label>
                <div style={styles.inputElementContainer}>
                  <Hash style={styles.inputInlineIcon} />
                  <input
                    name="order_number"
                    value={newOrder.order_number}
                    onChange={handleInputChange}
                    placeholder="Order No #"
                    style={styles.iconicInput}
                  />
                </div>
              </div>

              <div>
                <label style={styles.fieldLabel}>Order Booking Date</label>
                <div style={styles.inputElementContainer}>
                  <Calendar style={styles.inputInlineIcon} />
                  <input
                    type="date"
                    name="order_date"
                    value={newOrder.order_date}
                    onChange={handleInputChange}
                    style={styles.iconicInput}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: CRM Client Selection */}
          <div style={styles.cardLayout}>
            <div style={styles.cardHeadRow}>
              <Building2 style={{ width: '16px', height: '16px', color: '#7c3aed' }} />
              <h2 style={styles.cardHeadingTitle}>Customer Link Configuration</h2>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={styles.fieldLabel}>Select Target Client Account</label>
                <div style={styles.inputElementContainer}>
                  <select
                    name="customer_name"
                    value={newOrder.customer_name}
                    onChange={(e) => {
                      const selectedCustomer = customers.find((cust) => cust.name === e.target.value);
                      setNewOrder((prev) => ({
                        ...prev,
                        customer_name: selectedCustomer?.name || "",
                        customer_id: selectedCustomer?.id || "",
                      }));
                    }}
                    style={{ ...styles.standardInput, paddingRight: '36px', appearance: 'none' }}
                  >
                    <option value="">Select Interested Customer</option>
                    {customers.length > 0 ? (
                      customers.map((cust) => (
                        <option key={cust.id} value={cust.name}>
                          {cust.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No interested customers mapping available</option>
                    )}
                  </select>
                  <ChevronDown style={styles.customSelectChevron} />
                </div>
              </div>

              <div style={styles.adaptiveGrid2}>
                <div>
                  <label style={styles.fieldLabel}>Logistics Delivery Address</label>
                  <textarea
                    name="shipping_address"
                    value={newOrder.shipping_address}
                    onChange={handleInputChange}
                    placeholder="Provide detailed spatial route destination"
                    rows={3}
                    style={styles.customTextAreaLayout}
                  />
                </div>
                <div>
                  <label style={styles.fieldLabel}>Internal Record Notes</label>
                  <textarea
                    name="notes"
                    value={newOrder.notes}
                    onChange={handleInputChange}
                    placeholder="Enter process terms, comments, special guidelines"
                    rows={3}
                    style={styles.customTextAreaLayout}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Section 3: Item Insertion Subsystem */}
          <div style={styles.cardLayout}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Plus style={{ width: '16px', height: '16px', color: '#059669' }} />
                <h2 style={styles.cardHeadingTitle}>Add Items to Matrix Stack</h2>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '14px', borderRadius: '12px', backgroundColor: '#f9fafb', border: '1px solid #e5e7eb' }}>
              <div>
                <label style={styles.fieldLabel}>Product Source Selector</label>
                <div style={styles.inputElementContainer}>
                  <select
                    name="product_name"
                    value={newItem.product_name}
                    onChange={handleItemChange}
                    style={{ ...styles.standardInput, paddingRight: '36px', appearance: 'none', backgroundColor: '#ffffff' }}
                  >
                    <option value="">Select Product Catalog Item</option>
                    {products.map((p) => (
                      <option key={p.id} value={p.name}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  <ChevronDown style={styles.customSelectChevron} />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={styles.fieldLabel}>Thickness</label>
                  <input type="text" name="thickness" value={newItem.thickness} onChange={handleItemChange} placeholder="Gauge/Thickness" style={{ ...styles.standardInput, backgroundColor: '#ffffff' }} />
                </div>
                <div>
                  <label style={styles.fieldLabel}>Grade</label>
                  <input type="text" name="grade" value={newItem.grade} onChange={handleItemChange} placeholder="Quality Rating" style={{ ...styles.standardInput, backgroundColor: '#ffffff' }} />
                </div>
                <div>
                  <label style={styles.fieldLabel}>Dimension / Size</label>
                  <input type="text" name="size" value={newItem.size} onChange={handleItemChange} placeholder="Measurements" style={{ ...styles.standardInput, backgroundColor: '#ffffff' }} />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr auto', gap: '12px', alignItems: 'end' }}>
                <div>
                  <label style={styles.fieldLabel}>Unit Basic Price (₹)</label>
                  <input type="number" name="unit_price" value={newItem.unit_price} onChange={handleItemChange} placeholder="Rate allocation" style={{ ...styles.standardInput, backgroundColor: '#ffffff' }} />
                </div>
                <div>
                  <label style={styles.fieldLabel}>Quantity (Count/Vol)</label>
                  <input type="number" name="quantity" value={newItem.quantity} onChange={handleItemChange} placeholder="Volume units" style={{ ...styles.standardInput, backgroundColor: '#ffffff' }} />
                </div>
                <div>
                  <button onClick={handleAddItem} style={{ ...styles.actionSecondaryBtn, width: isMobile ? '100%' : 'auto', height: '40px' }}>
                    <Plus style={{ width: '15px', height: '15px' }} /> Push Item
                  </button>
                </div>
              </div>
            </div>

            {/* Render Matrix Elements Output Grid */}
            {newOrder.items.length > 0 && (
              <div style={{ marginTop: '20px', borderTop: '1px dashed #e5e7eb', paddingTop: '16px' }}>
                <label style={{ ...styles.fieldLabel, marginBottom: '10px' }}>Current Loaded Items Stack</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {newOrder.items.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', backgroundColor: '#fcfdfd', border: '1px solid #f0f2f5', borderRadius: '10px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <span style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>{item.product_name}</span>
                        <span style={{ fontSize: '11px', color: '#6b7280' }}>
                          {item.thickness && `Thick: ${item.thickness}`} {item.grade && `| Grade: ${item.grade}`} {item.size && `| Size: ${item.size}`}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <span style={{ fontSize: '13px', color: '#374151', fontWeight: '500' }}>
                          {item.quantity} units × ₹{item.unit_price.toFixed(2)}
                        </span>
                        <button
                          type="button"
                          onClick={() => handleRemoveItem(idx)}
                          style={{ border: 'none', backgroundColor: 'transparent', color: '#ef4444', cursor: 'pointer', padding: '4px' }}
                        >
                          <Trash2 style={{ width: '15px', height: '15px' }} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Column: Dynamic Matrix Financial Overview */}
        <div style={styles.stickySidebar}>
          
          <div style={styles.cardLayout}>
            <div style={styles.cardHeadRow}>
              <Landmark style={{ width: '16px', height: '16px', color: '#059669' }} />
              <h2 style={styles.cardHeadingTitle}>Financial Taxation Breakdowns</h2>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={styles.fieldLabel}>Tax Model Strategy Selection</label>
                <div style={styles.inputElementContainer}>
                  <select
                    name="gst"
                    value={newOrder.gst}
                    onChange={handleInputChange}
                    style={{ ...styles.standardInput, paddingRight: '36px', appearance: 'none' }}
                  >
                    <option value="">Select GST Framework</option>
                    {gstEntries.map((gst, index) => (
                      <React.Fragment key={index}>
                        <option value={`CGST ${gst.cgst}%`}>CGST {gst.cgst}%</option>
                        <option value={`SGST ${gst.sgst}%`}>SGST {gst.sgst}%</option>
                        <option value={`IGST ${gst.igst}%`}>IGST {gst.igst}%</option>
                      </React.Fragment>
                    ))}
                  </select>
                  <ChevronDown style={styles.customSelectChevron} />
                </div>
              </div>

              <div>
                <label style={styles.fieldLabel}>Global Margin Discount Deductions</label>
                <div style={styles.inputElementContainer}>
                  <Percent style={styles.inputInlineIcon} />
                  <input
                    name="discount"
                    value={newOrder.discount}
                    onChange={handleInputChange}
                    placeholder="Discount value reduction"
                    style={styles.iconicInput}
                  />
                </div>
              </div>

              <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: '14px', display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#4b5563' }}>
                  <span>Raw Calculated Subtotal</span>
                  <span style={{ fontWeight: '500' }}>₹{currentSubtotal.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#4b5563' }}>
                  <span>Computed Tax Level ({newOrder.gst || '0%'})</span>
                  <span style={{ fontWeight: '500' }}>₹{Number(newOrder.gst_amount || 0).toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#4b5563' }}>
                  <span>Assigned Markdown Discount</span>
                  <span style={{ fontWeight: '500', color: '#dc2626' }}>{newOrder.discount || 0}%</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #e5e7eb', paddingTop: '10px', marginTop: '4px' }}>
                  <span style={{ fontWeight: '600', color: '#111827' }}>Aggregated Total</span>
                  <span style={{ fontSize: '18px', fontWeight: '700', color: '#16a34a' }}>₹{Number(newOrder.total_amount || 0).toFixed(2)}</span>
                </div>
              </div>

              <div style={{ marginTop: '10px' }}>
                <button type="button" onClick={handleAddNewOrder} style={styles.actionPrimaryBtn}>
                  <Save style={{ width: '16px', height: '16px' }} />
                  {id ? "Update Configuration Profile" : "Commit Order Framework"}
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default SalesOrders;